import React, { useState } from 'react';

const Navbar = ({ logo, logoLight, isScrolled, imageHeight }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeLink, setActiveLink] = useState('#hero-area');

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLinkClick = (link) => {
        setActiveLink(link);
        setIsMenuOpen(false);
    };

    return (
        <nav className="navbar navbar-expand-lg fixed-top scrolling-navbar indigo">
            <div className="container">
                <div className="navbar-header">
                    <div className="slicknav_menu" style={{ width: '50%' }}>
                        {/* Mobile Menu Button */}
                        <span
                            aria-haspopup="true"
                            tabIndex="0"
                            className={`slicknav_btn ${
                                isMenuOpen
                                    ? 'slicknav_open'
                                    : 'slicknav_collapsed'
                            }`}
                            style={{ outline: 'none' }}
                            onClick={toggleMenu}
                        >
                            <span className="slicknav_menutxt"></span>
                            <span className="slicknav_icon slicknav_no-text">
                                <span className="slicknav_icon-bar"></span>
                                <span className="slicknav_icon-bar"></span>
                                <span className="slicknav_icon-bar"></span>
                            </span>
                        </span>

                        {/* Mobile Menu Items */}
                        <MobileMenu
                            isMenuOpen={isMenuOpen}
                            activeLink={activeLink}
                            handleLinkClick={handleLinkClick}
                        />
                    </div>
                    <a href="/#hero-area" className="navbar-brand">
                        <img
                            className="img-fluid"
                            src={isScrolled ? logoLight : logo}
                            alt="Logo"
                            title="easyILA Logo"
                            loading="lazy"
                            style={{ height: imageHeight, width: 'auto' }}
                        />
                    </a>
                </div>
                <div className="collapse navbar-collapse" id="main-navbar">
                    <DesktopMenu
                        activeLink={activeLink}
                        handleLinkClick={handleLinkClick}
                    />
                </div>
            </div>
        </nav>
    );
};

const MobileMenu = ({ isMenuOpen, activeLink, handleLinkClick }) => {
    return (
        <ul
            className={`slicknav_nav ${
                isMenuOpen ? 'slicknav_visible' : 'slicknav_hidden'
            }`}
            style={{ paddingBottom: '5px', textAlign: 'center' }}
            aria-hidden={!isMenuOpen}
            role="menu"
        >
            <NavItem
                link="/"
                text="Home"
                activeLink={activeLink}
                handleLinkClick={handleLinkClick}
                isButton
            />
        </ul>
    );
};

const DesktopMenu = ({ activeLink, handleLinkClick }) => {
    return (
        <ul className="navbar-nav mr-auto w-100 justify-content-end">
            <NavItem
                link="/"
                text="Home"
                activeLink={activeLink}
                handleLinkClick={handleLinkClick}
                isButton
                buttonStyle={{
                    backgroundColor: '#61D2B4',
                    color: 'black',
                    marginLeft: '5px',
                    padding: '0 65px',
                }}
            />
        </ul>
    );
};

const NavItem = ({
    link,
    text,
    activeLink,
    handleLinkClick,
    isButton = false,
    buttonStyle = {},
}) => {
    return (
        <li className="nav-item">
            <a
                className={`nav-link page-scroll ${
                    activeLink === link ? 'active' : ''
                } ${isButton ? 'nav-button' : ''}`}
                href={link}
                onClick={() => handleLinkClick(link)}
                style={isButton ? buttonStyle : {}}
                role={isButton ? 'menuitem' : undefined}
                tabIndex={isButton ? '-1' : undefined}
            >
                {text}
            </a>
        </li>
    );
};

export default Navbar;
